import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const SeasonalThemeContext = createContext({ theme: null, loading: true });
const api = process.env.REACT_APP_BACKEND_URL;

export function SeasonalThemeProvider({ children }) {
  const [theme, setTheme] = useState(null); const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    const previewKey = new URLSearchParams(window.location.search).get('theme_preview');
    const load = () => axios.get(`${api}/api/public/site-theme${previewKey ? `?preview_key=${encodeURIComponent(previewKey)}` : ''}`)
      .then((res) => { if (active) setTheme(res.data); })
      .catch(() => { if (active) setTheme(null); })
      .finally(() => { if (active) setLoading(false); });
    load(); const timer = setInterval(load, 30000);
    return () => { active = false; clearInterval(timer); };
  }, []);
  useEffect(() => {
    const root = document.documentElement; const body = document.body; const tokens = theme?.tokens;
    if (!theme || theme.status === 'default' || !tokens) { body.removeAttribute('data-seasonal-theme'); return undefined; }
    root.style.setProperty('--seasonal-primary', tokens.primary || '#16a34a');
    root.style.setProperty('--seasonal-secondary', tokens.secondary || '#0a2540');
    root.style.setProperty('--seasonal-accent', tokens.accent || '#60a5fa');
    root.style.setProperty('--seasonal-page-bg', tokens.page_bg || '#fff');
    root.style.setProperty('--seasonal-text', tokens.text || '#102a43');
    root.style.setProperty('--seasonal-hero-gradient', tokens.hero_gradient || 'linear-gradient(135deg,#0a2540,#123b67)');
    root.style.setProperty('--seasonal-hero-image', tokens.hero_background_image ? `url(${tokens.hero_background_image})` : 'none');
    body.setAttribute('data-seasonal-theme', theme.template_key || 'custom');
    return () => { body.removeAttribute('data-seasonal-theme'); };
  }, [theme]);
  return <SeasonalThemeContext.Provider value={{ theme, loading }}>{children}</SeasonalThemeContext.Provider>;
}
export const useSeasonalTheme = () => useContext(SeasonalThemeContext);